import { render, staticRenderFns } from "./TableColumnsMenu.vue?vue&type=template&id=77805147&scoped=true&"
import script from "./TableColumnsMenu.vue?vue&type=script&lang=ts&"
export * from "./TableColumnsMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77805147",
  null
  
)

export default component.exports